export const housekeeping = {
  // ── Page (index) ──
  title: "Limpeza",
  remindersBtn: "Lembretes",
  refresh: "Atualizar",
  aboutToLeaveTitle: "Hóspedes prestes a sair hoje",
  aboutToLeaveCount: "{count} prestes a sair",
  remindersTitle: "Configurar lembretes de limpeza",

  headline: {
    allDone: "Tudo em dia! Nada para limpar agora.",
    inProgress: "Limpeza em andamento · {count} em andamento",
    toClean: "O que precisa de limpeza hoje? {count} para limpar",
    toCleanWithProgress: "O que precisa de limpeza hoje? {toClean} para limpar · {inProgress} em andamento",
  },

  allProperties: "Todas as propriedades",
  searchPlaceholder: "Buscar quarto, hóspede…",

  // Status filter chips (label)
  chips: {
    all: "Todos",
    to_clean: "Para limpar",
    in_progress: "Em andamento",
    occupied: "Ocupado",
    clean: "Disponível",
    out_of_service: "Fora de serviço",
  },
  // Status filter chips (tooltip)
  chipTips: {
    all: "Todos os espaços de hoje, sem filtro.",
    to_clean: "Limpeza pendente: marcados como sujos, com saída hoje e não limpos, ou estadias longas vencidas conforme o intervalo.",
    in_progress: "Limpeza em andamento agora.",
    occupied: "Hóspede dentro (estadia em andamento, sem saída hoje).",
    clean: "Limpo e pronto para o próximo hóspede (inclui os inspecionados).",
    out_of_service: "Indisponível para limpar (falha ou manutenção).",
  },

  loadingBoard: "Carregando o painel…",
  emptyToClean: "Tudo limpo! Nenhum espaço pendente agora.",
  emptyStatus: "Nenhum espaço neste status.",
  emptySearch: "Nenhum espaço corresponde à sua busca.",

  typeHotel: "Hotel",
  typeApartment: "Apartamento",

  // Row badges
  stayDue: "Limpeza vencida",
  hourlyStayDue: "Saída por horas",
  hourlyStayAt: "Saiu às {time}",
  overdue: "Atrasada",
  overdueSince: "Sem limpeza desde {date} · {days} dias",
  overdueGuests: "{n} hóspedes saíram sem limpeza registada",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "Das {from} às {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "Passou da hora",
  alreadyLeft: "Já saiu",
  aboutToLeave: "Prestes a sair",
  cleanBadge: "Limpo",
  inspectedBadge: "Inspecionado",

  // Turnover (one leaves / another arrives)
  departs: "↑ Saída",
  arrives: "↓ Entrada",
  guestFallback: "Hóspede",
  departsOn: "· sai {date}",

  // Row actions
  assign: "Atribuir",
  reassignTitle: "Reatribuir quem limpa",
  assignWhoTitle: "Atribuir quem limpa",
  start: "Iniciar",
  startTitle: "Marcar em andamento",
  cleanAction: "Limpar",
  cleanTitle: "Concluir limpeza (fotos e notas)",
  tasks: "Tarefas",
  tasksTitle: "Tarefas e detalhes",

  toastSaved: "Lembretes de limpeza atualizados",

  // Effective status (label)
  status: {
    to_clean: "Para limpar",
    in_progress: "Em andamento",
    occupied: "Em uso",
    clean: "Disponível",
    inspected: "Inspecionado",
    out_of_service: "Fora de serviço",
  },
  // Effective status (tooltip)
  statusTip: {
    to_clean: "Aguardando limpeza.",
    in_progress: "Limpeza em andamento.",
    occupied: "Em uso: hóspede dentro.",
    clean: "Limpo e pronto para o próximo hóspede.",
    inspected: "Limpo e verificado por um supervisor.",
    out_of_service: "Fora de serviço: não pode ser limpo (falha/manutenção).",
  },
  // Occupancy (label)
  occupancy: {
    vacant: "Vago",
    occupied: "Ocupado",
    departure_today: "Sai hoje",
    arrival_today: "Chega hoje",
    turnover: "Saída e chegada",
  },
  // Occupancy (tooltip)
  occupancyTip: {
    vacant: "Sem hóspede: livre.",
    occupied: "Hóspede dentro (estadia em andamento).",
    departure_today: "O hóspede sai hoje: vai precisar de limpeza.",
    arrival_today: "Um hóspede chega hoje: precisa estar pronto a tempo.",
    turnover: "Um hóspede sai e outro chega hoje: limpeza urgente no intervalo.",
  },

  roles: {
    limpieza: "Limpeza",
    mantenimiento: "Manutenção",
    recepcion: "Recepção",
    gestor: "Gestor",
    propietario: "Proprietário",
  },

  // Mid-stay cleaning reason
  stayTip: {
    fallback: "Limpeza de estadia vencida",
    daysSince: "{count} dia | {count} dias",
    interval: "todo dia | a cada {count} dias",
    main: "O hóspede ainda está hospedado. Já faz {since} sem limpeza e deve ser feita {interval}.",
  },

  // Cleaning-window timer
  timer: {
    approx: " (aprox.)",
    overdue: "Chegada atrasada",
    overdueTitle: "O horário de chegada ({checkin}) já passou · priorize esta limpeza",
    remaining: "{dur} até a chegada",
    remainingTitle: "{dur} restantes até a chegada ({checkin})",
  },

  // ── Reminders modal ──
  remind: {
    title: "Lembretes de limpeza",
    subtitle: "Avise sua equipe quando um quarto com chegada/saída próxima não estiver pronto.",
    close: "Fechar",
    scopeLabel: "Quais propriedades?",
    scopeOne: "Esta propriedade",
    scopeAll: "Todas",
    summary: "{enabled} de {total} propriedades com lembretes ativos.",
    propertyLabel: "Propriedade",
    activeSuffix: " · ativo",
    propertyHelp: "Cada propriedade mantém seu próprio agendamento.",
    allNotePre: "As mesmas configurações se aplicarão às suas ",
    allNotePost: " propriedades (cada uma no seu horário local).",
    arrivalsTitle: "Chegadas e saídas",
    longStayTitle: "Reservas de longa estadia",
    daysBeforeLabel: "Com quanta antecedência?",
    daysBefore: {
      same: "Somente no mesmo dia",
      upTo: "Até {count} dia antes | Até {count} dias antes",
    },
    daysBeforeHelp: "Considera chegadas/saídas dentro deste período.",
    intervalLabel: "Quantos dias entre as limpezas?",
    interval: "Todo dia | A cada {count} dias",
    intervalHelp: "Contado a partir da última limpeza. O quarto aparecerá em 'Para limpar' mesmo enquanto ainda ocupado.",
    timeLabel: "A que horas são enviados?",
    timeHelp: "Horário local da propriedade. Uma vez por dia.",
    recipientsLabel: "Quem é notificado?",
    note: "São enviados por uma fila (notificação + push) e cada alerta fica registrado nas notificações.",
    cancel: "Cancelar",
    saving: "Salvando…",
    saveAll: "Salvar para todas",
    save: "Salvar",
    recipients: {
      assigned: "Atribuídos",
      team: "Equipe",
      both: "Ambos",
    },
    recipientHelp: {
      assigned: "Apenas as pessoas atribuídas a esse quarto.",
      team: "Toda a equipe de limpeza/manutenção da propriedade.",
      both: "Os responsáveis e a equipe da propriedade.",
    },
    longStayOff: "Desativado",
    longStaySub: "Todo dia da estadia | A cada {count} dias da estadia",
    toggleAllOn: "Será ativado para todas",
    toggleAllOff: "Será desativado para todas",
    toggleOneOn: "Ativado para esta propriedade",
    toggleOneOff: "Desativado",
  },

  // ── Complete-cleaning modal ──
  complete: {
    title: "Concluir limpeza",
    dropStrong: "Arraste as fotos aqui",
    dropRest: "ou clique para selecionar",
    dropHint: "Evidência do estado do quarto · JPG, PNG, WEBP",
    photoAlt: "foto",
    saved: "Salvo",
    view: "Ver",
    remove: "Remover",
    notes: "Notas",
    notesPlaceholder: "Problemas, danos, itens faltando… (opcional)",
    cancel: "Cancelar",
    uploading: "Enviando… {pct}%",
    saving: "Salvando…",
    submit: "Marcar como limpo",
    previewAlt: "prévia",
  },

  // ── Assign modal ──
  assignModal: {
    title: "Quem limpa este espaço?",
    allOption: "Todos",
    allDesc: "Visível para toda a equipe de limpeza e manutenção",
    roleSection: "Atribuir a uma função",
    peopleTitle: "Ou escolha pessoas",
    peopleHint: "(uma ou mais)",
    emptyPre: "Você ainda não tem membros na equipe. Você pode atribuir por função ou adicionar pessoas em ",
    emptyTeam: "Equipe",
    emptyPost: ".",
    cancel: "Cancelar",
    saving: "Salvando…",
    save: "Salvar atribuição",
  },

  // ── Planeamento: o calendário das limpezas futuras ──
  plan: {
    title: "Planeamento de limpezas",
    viewToday: "Hoje",
    viewPlan: "Planeamento",
    loading: "A carregar o calendário…",
    loadError: "Não foi possível carregar o calendário.",
    saveError: "Não foi possível guardar. Tente novamente.",
    empty: "Não há limpezas nestas datas.",
    space: "Espaço",
    prev: "Dias anteriores",
    next: "Dias seguintes",
    today: "Hoje",
    days: "{n} dias",
    anyone: "Qualquer pessoa",
    unassigned: "Sem atribuição",
    headline: {
      nothing: "Não há nada pendente nestas datas.",
      all: "{total} limpezas pendentes · {urgentes} urgentes",
      withOrphans: "{total} pendentes · {urgentes} urgentes · {sin} sem atribuição",
    },
    types: {
      turnover: "Sai e entra",
      arrastre: "Atrasada",
      salida: "Saída",
      estancia: "Estadia longa",
      manual: "Marcada à mão",
    },
    abbr: { all: "TOD", turnover: "TURN", arrastre: "ATR", salida: "SAI", estancia: "EST", manual: "MAN" },
    windowGuessed: "Horas da casa: este alojamento não tem as suas definidas",
    legendTight: "Margem apertada entre a saída e a entrada",
    noRoomTip: "{n} saídas ainda sem quarto atribuído",
    windowTip: "Entre a saída ({desde}) e a entrada ({hasta}) há {min} minutos",
    roleShort: "FUNÇ",
    roleFull: "Atribuída a uma função, não a uma pessoa",
    fromSpace: "atribuição fixa do espaço",
    nobody: "Sem atribuição — clique para escolher alguém",
    dow: { mon: "S", tue: "T", wed: "Q", thu: "Q", fri: "S", sat: "S", sun: "D" },

    teamRows: "Distribuição da equipa",

    teamTitle: "Equipa",
    capacity: "Capacidade",
    capacityTitle: "Quantas limpezas cada pessoa aguenta por dia",
    done: "Pronto",
    perDay: "Por dia",
    dayOffTip: "Marcar como dia de descanso",
    noStaff: "Ainda não tem pessoal de limpeza. Adicione pessoas em Equipa e a carga aparecerá aqui.",
    shortHands: "Faltam mãos: {dias}",
    loadTip: "{dia}: {n} de {cap}",
    loadTipOff: "{dia}: dia de descanso ({n} atribuídas)",
    hasNow: "{n} atribuídas · aguenta {cap} por dia",

    selected: "{n} selecionadas",
    assignTo: "Atribuir a…",
    assignBtn: "Atribuir {n}",
    people: "Pessoas",
    noteTitle: "Nota para esta limpeza",
    notePlaceholder: "Chega tarde, dê prioridade…",
    unassign: "Retirar",
    clear: "Limpar seleção",
    assigned: "{n} limpezas atribuídas",
    unassigned2: "Atribuição retirada",
    partial: "{n} atribuídas, {mal} não foi possível",
    autoAssign: "Distribuir automaticamente",
    nothingToAssign: "Não há nada sem atribuição nestas datas.",
    proposalTitle: "Proposta de distribuição",
    proposalSub: "{n} limpezas distribuídas. Reveja antes de aplicar.",
    proposalApply: "Aplicar a distribuição",
    proposalUncovered: "{n} sem cobertura",
    cancel: "Cancelar",
    uncovered: {
      nadie_tiene_esta_propiedad: "ninguém tem essa propriedade atribuída",
      nadie_trabaja_ese_dia: "ninguém trabalha nesse dia",
      equipo_lleno: "a equipa está no limite",
    },
    rejected: {
      espacio_ajeno: "Esse espaço não é da sua conta.",
      persona_ajena: "Essa pessoa não é da sua equipa.",
      persona_sin_la_propiedad: "Essa pessoa não tem esta propriedade atribuída. Atribua-a primeiro em Equipa.",
      rol_desconocido: "Essa função não existe.",
      datos_incompletos: "Faltam dados da limpeza.",
      error_al_guardar: "Não foi possível guardar.",
    },
    autoAssignN: "Distribuir {n}",
    seeDay: "Ver o dia",
    filtering: "A filtrar por",
    showingOf: "a ver {n} de {total}",
    emptyFiltered: "Nada corresponde a estes filtros. Há {total} limpezas nestas datas.",
    moreFilters: "Mais filtros",
    roomy: "Cómoda",
    dense: "Compacta",
    ofN: "de {n} limpezas",
    addPerson: "Adicionar alguém à equipa",
    notCleaner: "Não é pessoal de limpeza, mas tem trabalho atribuído",
    teamCap: "{n} por dia",
    teamFoot: "A carga é de todo o período; os filtros não a alteram.",
    perDayN: "{n} por dia",
    closedN: "{n} fechadas",
    capMax: "O máximo são {n} por dia",
    rowHint: "Alt + clique para escolher a linha toda",
    daySheetTip: "Clique para ver o dia · Alt + clique para escolhê-lo todo",
    keysHint: "1-9 atribui · A abre · Esc limpa",
    undo: "Anular",
    undone: "Distribuição reposta",
    tightDay: "{dia} tem {n} limpezas",
    tightMore1: "e mais 1 dia",
    tightMoreN: "e mais {n} dias",
    proposalDetail: "Ver a distribuição limpeza a limpeza",
    nobody2: "Ainda ninguém",
    warnDayOff: "{quien} folga em {dia}.",
    warnOver: "{quien} fica com {n} em {dia} e aguenta {cap}.",
    onDay: "{dia}: {n} + {mas} de {cap}",
    onDays: "{dias} dias: {n} de {cap}",
    c: {
      pending: "Pendentes",
      urgent: "Urgentes",
      tight: "Dias apertados",
      done: "Feitas",
      noRoom: "Sem quarto",
    },
    rows: {
      withWork: "com trabalho",
      all: "todos",
      help: "«Todos» mostra também os espaços que nestas datas não é preciso limpar.",
      forced: "Com um filtro ativo só se mostram os espaços que têm trabalho.",
    },
    f: {
      any: "Qualquer",
      urgency: "Urgência",
      window: "Janela",
      state: "Estado",
      unitType: "Tipo de espaço",
      clear: "Limpar filtros",
    },
    urg: {
      urgente: "Entra alguém nesse dia",
      alta: "Entra no dia seguinte",
      normal: "Entra em 2-3 dias",
      baja: "Ninguém entra a seguir",
    },
    holg: { amplia: "Folgada", justa: "Apertada", imposible: "Não dá tempo" },
    estados: { pendiente: "Pendente", en_curso: "Em curso", hecha: "Feita", fuera_de_servicio: "Fora de serviço" },
    motivos: {
      faltan_manos: "faltam mãos para {n}",
      con_hora_limite: "{n} com hora limite",
      varios_edificios: "{n} edifícios diferentes",
    },
    sheet: {
      autoDay: "Distribuir este dia",
      assignAll: "Atribuir as {n}",
      nCleanings: "{n} limpezas",
      nUnassigned: "{n} sem atribuição",
      covers: "a equipa cobre {n}",
      empty: "Nada para limpar neste dia.",
    },
    tip: {
      outIn: "sai · entra",
      lateSold: "saída tardia vendida",
      earlySold: "entrada antecipada",
      noName: "Sem nome",
      pax: "{n} pax",
      nights: "{n} noites",
      min: "{n} min",
      h: "{h} h",
      hm: "{h} h {m}",
      stillIn: "continua alojado",
      freeNobody: "fica livre",
      freeNone: "entra outro",
      freeDay1: "livre 1 dia",
      freeDaysN: "livre {n} dias",
      houseHours: "horas da casa",
      openSpace: "Ficha do espaço", openSpaceHint: "Abre no quadro de Hoje, com o estado, as tarefas e o histórico",
      select: "Escolher",
      deselect: "Tirar da seleção",
      assignedBy: "Atribuído por {quien}",
    },
  },
};
